import React from "react";
import styles from "./topics.module.scss";

const data = [
  {
    id: 1,
    title: "On-Spot Profile Assessment",
  },
  {
    id: 2,
    title: "Personalized Program Shortlisting",
  },
  {
    id: 3,
    title: "Tailored Application Guidance",
  },
  {
    id: 4,
    title: "Visa Process Breakdown",
  },
  {
    id: 5,
    title: "Scholarship Options",
  },
  {
    id: 6,
    title: "Work Opportunities for Students",
  },
];

export const EventTopics = () => {
  return (
    <section>
      <div className="container">
        <div className={styles.heading_container}>
          <h1 className={styles.heading}>Event Highlights</h1>
          <p>
            Connect one-to-one with university representatives from US
            institutions for:
          </p>
        </div>

        <div className={styles.topics_container}>
          {data?.map((item, i) => {
            return (
              <div key={i} className={styles.card_container}>
                <div className={styles.card_body}>
                  <h4>{item?.title}</h4>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EventTopics;
